import React, { useEffect, useState } from 'react'
import BlogBanner from './BlogBanner'
import { useSelector } from 'react-redux';
import { apiData } from '../../../actions';
import Blog from './Blog';
import Favorite from '../../../assets/images/Favorite-bg5.png'

export default function BlogMain() {

  const place = useSelector((state) => state.place);
  const [loader, setLoader] = useState(false);
  const [blog, setBlog] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [visibleCount, setVisibleCount] = useState(12);

  const loadMore = async () => {
    const payload = {
      key: keyword,
      place: place,
    }
    try {
      setLoader(true);
      const apiRes = await apiData.blog(payload);

      if (apiRes?.status >= 200 && apiRes?.status <= 399) {
        setBlog(apiRes?.data?.data || []);
        setVisibleCount(12);
      } else {
        setBlog([]);
      }
    } catch (error) {
      console.error("Yelp API Error:", error);
      setBlog([]);
    } finally {
      setLoader(false);
    }
  }

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 10); // ✅ add 10 more
  };

  useEffect(() => {
    loadMore();
  }, [keyword, place]);

  return (
    <>
      <BlogBanner keyword={keyword} setKeyword={setKeyword} />
      <Blog blog={blog} loader={loader} visibleCount={visibleCount} onLoadMore={handleLoadMore} />
      <section className="section-equal-padding favorite-section things-favorite uk-scrollspy-inview"
        style={{ backgroundImage: `url(${Favorite})` }}
        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
        <div className="container d-flex justify-content-center text-center">
          <div className="favorite-block uk-scrollspy-inview"
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false" >
            <h2 className="mb-4">Get Ready for an Adventure!</h2>
            <p>
              Start your journey with us, where we guarantee the lowest prices. Book top hotel rooms for $20-$30
              less per night and save $25-$50 on flights compared to other travel sites. Explore our site, grab
              great deals, and let the thrill of savings fuel your dream getaway!
            </p>
            <a href="" className="white-btn mt-3">Browse Full Menu</a>
          </div>
        </div>
      </section>
    </>
  )
}
